const IMetricsClient = require("./IMetricsClient.js");
const SegmentBrowserClient = require("./SegmentBrowserClient.js");
const SegmentNodeClient = require("./SegmentNodeClient.js");
const SentryClient = require("./SentryClient.js");
const {
  createMetricsClient,
  METRICS_PROVIDERS,
  METRICS_RUNTIMES
} = require("./createMetricsClient.js");

module.exports = {
  IMetricsClient,
  SegmentBrowserClient,
  SegmentNodeClient,
  SentryClient,
  DEFAULT_ALLOWED_ATTRIBUTES: SentryClient.DEFAULT_ALLOWED_ATTRIBUTES,
  createMetricsClient,
  METRICS_PROVIDERS,
  METRICS_RUNTIMES
};
